// Ausgelagerte, häufig verwendete Funktionen
export { setCookie, getCookie, setAlert, disableCookies };

var enableCookies = true
function disableCookies() {
    enableCookies = false
}

function setCookie(cookie) {
    if(!enableCookies)
        return
    var d = new Date()
    d.setTime(d.getTime() + (cookie.exdays*24*60*60*1000))
    var expires = "expires="+ d.toUTCString()
    document.cookie = cookie.name + "=" + cookie.value + ";" + expires + ";path=/"
}

function getCookie(name){
    var cookies = document.cookie.split('; ')
    for(var x of cookies){
        var cookie = x.split('=')
        if(cookie[0] == name)
            return cookie[1]
    }
    return undefined
}

function setAlert(that, message, title, variant)
{
    that.$bvToast.toast(message, {
        title: title,
        variant: variant,
        toaster: 'b-toaster-top-right',
        autoHideDelay: 5000,
        appendToast: true
    })
}